export const INITIAL_ORDER_FILTERS = {
  accountIn: [],
  accountIsUnassigned: false,
  contactIn: [],
  contactIsUnassigned: false,
  salespersonIn: [],
  salespersonIsUnassigned: false,
  estimatorIn: [],
  estimatorIsUnassigned: false,
  totalPrice: undefined,
  paymentStatus: undefined,
  orderedDate: undefined,
  processIn: [],
};
